import { render, staticRenderFns } from "./remove-user.vue?vue&type=template&id=0e3b7918&"
import script from "./remove-user.ts?vue&type=script&lang=ts&"
export * from "./remove-user.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports